import { Modal as ModalComponent } from 'decentraland-ui/dist/components/Modal/Modal';
import BaseModal from './Modal.container';
const Modal = BaseModal;
Modal.Actions = ModalComponent.Actions;
Modal.Content = ModalComponent.Content;
Modal.Description = ModalComponent.Description;
Modal.Header = ModalComponent.Header;
export default Modal;
//# sourceMappingURL=index.js.map